if (tipoBaseLp === 'vsl') {
  // ------------------------------------
  // EXIBIÇÃO
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $section = $('#bonus');

      // Oculta/Exibe a seção
      function changeSecShow() {
        const value = confTheme[ref2]['bonus-show'];
        value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
    }
  })();

  // ------------------------------------
  // PLANO DE FUNDO
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $section = $('#bonus');

      // Altera o tipo de fundo
      function changeBgType() {
        const value = confTheme[ref2]['bg-type'];
        if (value == 'image') {
          changeBgImage();
        } else if (value == 'gradient') {
          changeBgGradient();
        } else if (value == 'color') {
          changeBgColor();
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

      // Altera a imagem de fundo
      function changeBgImage() {
        const image = confTheme[ref2]['bg-image'];
        $section.css('background-image', 'url(' + image + ')');
      }
      $root.on(refEvtPrefix + 'bg-image', changeBgImage);

      // Altera o gradiente de fundo
      function changeBgGradient() {
        const value = confTheme[ref2]['bg-gradient'];
        $section.css('background-image', value);
      }
      $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

      // Altera a cor de fundo
      function changeBgColor() {
        const color = confTheme[ref]['bonus-bg-color'];
        $section.css('background-image', 'none');
        $section[0].style.setProperty('--bonus-bg-color', color);
      }
      $root.on(refEvtPrefix + 'bg-color', changeBgColor);
    }
  })();

  // ------------------------------------
  // TEXTOS
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $section = $('#bonus');
      const $secTitle = $('.bonus-sec-titulo');
      const $secText = $('.bonus-sec-texto');
      const $textosWrp = $('.bonus-textos-wrp');

      // Altera o título
      function changeTitle() {
        const value = confTheme[ref2]['titulo'];
        $secTitle.html(fmtTxt(value, true));
        handleTxtView();
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

      // Altera a cor do título
      function changeTitColor() {
        const color = confTheme[ref]['bonus-tit-color'];
        $section[0].style.setProperty('--bonus-tit-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

      // Altera o texto
      function changeText() {
        const value = confTheme[ref2]['texto'];
        $secText.html(fmtTxt(value));
        handleTxtView();
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

      // Altera a cor do texto
      function changeTxtColor() {
        const color = confTheme[ref]['bonus-txt-color'];
        $section[0].style.setProperty('--bonus-txt-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

      // Oculta os textos caso sejam em branco
      function handleTxtView() {
        if ($secTitle.length > 0 && $secText.length > 0) {
          const titulo = $secTitle.text().trim();
          const texto = $secText.text().trim();
          if (titulo == '' && texto == '') {
            $textosWrp.addClass('d-none');
          } else {
            $textosWrp.removeClass('d-none');
          }
        }
      }
      $(window).on('load', handleTxtView);

      // Altera a cor de destaque do texto
      function changeTxtAltColor() {
        const color = confTheme[ref]['txt-alt-color'];
        $section[0].style.setProperty('--txt-alt-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

      // Altera a cor de fundo do texto
      function changeTxtBgColor() {
        const color = confTheme[ref]['txt-bg-color'];
        $section[0].style.setProperty('--txt-bg-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
    }
  })();

  // ------------------------------------
  // IMAGEM
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $image = $('.bonus-imagem');

      // Altera a imagem
      function changeImage() {
        const image = confTheme[ref2]['img-src'];
        $image.find('img').attr('src', image);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-src', changeImage);

      // Altera o texto alternativo da imagem
      function changeImageAlt() {
        const value = confTheme[ref2]['img-alt'];
        $image.find('img').attr('alt', value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-alt', changeImageAlt);

      // Altera o formato da imagem
      function changeImageFormat() {
        const value = confTheme[ref2]['img-format'];
        $image.find('.img').removeClass('img-square img-rounded img-circle').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'img-format', changeImageFormat);
    }
  })();

  // ------------------------------------
  // BOTÃO
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $secButton = $('.bonus-botao');

      // Oculta/Exibe o botão
      function changeBtnShow() {
        const value = confTheme[ref2]['btn-show'];
        value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

      // Altera a classe do botão
      function changeBtnClass() {
        const value = confTheme[ref2]['btn-class'];
        const styleClass = confTheme['general'][value + '-style'];
        const AnimationClass = confTheme['general'][value + '-animation'];
        $secButton
          .find('.btn')
          .removeClass(btnClassesRem)
          .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

      // Altera o texto do botão
      function changeBtnText() {
        const value = confTheme[ref2]['btn-text'];
        $secButton.find('.btn').text(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);

      // Oculta/Exibe o selo
      function changeSealShow() {
        const value = confTheme[ref2]['seal-show'];
        value == '1'
          ? $secButton.find('.btn-selos').removeClass('d-none')
          : $secButton.find('.btn-selos').addClass('d-none');
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
    }
  })();

  // ------------------------------------
  // DIVISOR
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Altera o divisor
      function changeDivider() {
        const value = confTheme[ref2]['divisor'];
        $('.bonus-sec .section-divider').addClass('d-none');
        if (value) {
          $('.bonus-sec .section-divider.' + value).removeClass('d-none');
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

      // Altera a cor do divisor
      function changeDividerColor() {
        const color = confTheme[ref]['divisor-color'];
        $('#bonus')[0].style.setProperty('--divisor-color', color);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
    }
  })();

  // ------------------------------------
  // LISTA
  // ------------------------------------
  (function () {
    'use strict';
    if (previewMode) {
      // Variáveis
      const ref = 'bonus-var';
      const ref2 = 'bonus';
      const refEvtPrefix = 'lp-evt-bonus-';

      // Elementos
      const $list = $('#carrosel-bonus');

      // Altera a lista
      function changeList() {
        const lista = confTheme[ref2]['lista'];
        const imgFormat = confTheme[ref2]['lista-img-format'];
        if ($list.length > 0) {
          bonusDestroySlick();
          $list.html('');
          for (let i = 0; i < lista.length; i++) {
            const item = `
          <div class="carousel-item bonus-wrapper" data-aos="zoom-in" data-aos-offset="0">
            <div class="bonus">
              <figure class="img img-adaptive ${imgFormat} bonus-foto">
                <img src="${lista[i].img}" alt="${lista[i].alt}">
              </figure>
              <div class="bonus-infos">
                <div class="bonus-titulo md-text">${fmtTxt(lista[i].titulo, true)}</div>
                <div class="bonus-texto md-text">${fmtTxt(lista[i].texto, true)}</div>
              </div>
            </div>
          </div>`;
            $list.append(item);
          }
          refreshBonusDestSlick();
        }
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);

      // Altera o formato da imagem
      function changeImageFormat() {
        const value = confTheme[ref2]['lista-img-format'];
        $list.find('.img').removeClass('img-square img-rounded img-circle').addClass(value);
      }
      $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista-img-format', changeImageFormat);
    }
  })();
}
function refreshBonusDestSlick() {
  if (previewMode) {
    const ref = 'bonus-var';
    const ref2 = 'bonus';
    const showBlocos = confTheme[ref2]['bonus-show'];
    bonusDestroySlick();
    if (showBlocos == 1) {
      bonusInitSlick();
      setTimeout(() => {
        $('#carrosel-bonus')[0].slick.refresh();
      }, 100);
    }
  }
}
